import { BrandLogo } from "./BrandLogo";
import { C, font, radii, shadows, space, type } from "../styles/tokens";

/**
 * FormHeader - follows latest Brand Manual (Section 8).
 *
 * 2026 Brand spec:
 *   - Logo or brand mark on top
 *   - h2: title style (24px, 700, navy)
 *   - 2024 accent bar (44x3) is retired per Brand Manual Section 8.
 *   - Subtitle: color textMuted, 14-15px
 */
export function FormHeader({ title, subtitle }) {
  return (
    <div style={{ marginBottom: space.lg, textAlign: "center" }}>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: space.md }}>
        <BrandLogo mark={28} text={15} />
      </div>
      <h2
        style={{
          fontSize: type.title.fontSize,
          fontWeight: type.title.fontWeight,
          lineHeight: type.title.lineHeight,
          color: C.navy,
          margin: "0 0 6px",
          fontFamily: font,
        }}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          style={{
            color: C.textMuted,
            fontSize: type.caption.fontSize,
            lineHeight: type.caption.lineHeight,
            margin: 0,
            fontFamily: font,
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}

/**
 * CenteredForm - the white brand card wrapper used on auth/action pages.
 *
 * Brand spec: background #F7F9FC, white card (radius 16, card shadow, borderless).
 */
export function CenteredForm({ children, wide = false, isMobile = false }) {
  return (
    <div
      style={{
        backgroundColor: C.background,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "24px 16px 80px" : "36px 20px",
        fontFamily: font,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: wide ? 560 : 440,
          margin: "0 auto",
          backgroundColor: C.surface,
          padding: isMobile ? space.lg : space.xxl,
          borderRadius: radii.card,
          boxShadow: shadows.card,
          boxSizing: "border-box",
        }}
      >
        {children}
      </div>
    </div>
  );
}
